import {
    EstablishmentCard,
    EmptyListNotice,
} from "@hatch-digital-nl/abs-storybook/legacy";
import warningImage from "../../../common/images/warning.svg";
import checkCircleImage from "../../../common/images/check_circle.svg";
import loginImage from "../../../common/images/login.svg";
import {
    setEstablishment,
    setIsConformationModalOpen,
} from "../EstablishmentsSlice";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { useGetEstablishmentsQuery } from "../../../common/api/establishment";
import { useEmployeeId } from "../../../common/utils/useEmployeeId";
import Skeleton from "react-loading-skeleton";
import { EstablishmentsPopup } from "./EstablishmentsPopup";
import { JSX } from "react";
import { useGetQualificationsQuery } from "../../../common/api/qualification";
import { QualificationStandardEnum } from "../../../common/enums/QualificationStandardEnum";
import { useGetQualificationStandardIdByCode } from "../../../common/utils/useGetQualificationStandardIdByCode";
import { getTotalBrancheCount } from "../../../common/utils/getTotalBrancheCount";
import { getTotalPlusCount } from "../../../common/utils/getTotalPlusCount";

export const EstablishmentsContent = (): JSX.Element => {
    const dispatch = useAppDispatch();
    const { searchTerm } = useAppSelector((state) => state.establishments);
    const brancheId = useGetQualificationStandardIdByCode(
        QualificationStandardEnum.BRANCHE,
    );
    const plusId = useGetQualificationStandardIdByCode(
        QualificationStandardEnum.PLUS,
    );
    const {
        data: establishmentsData,
        isLoading: establishmentsDataIsLoading,
        isFetching: establishmentsDataIsFetching,
    } = useGetEstablishmentsQuery({
        items_per_page: 9999,
        filter: {
            ...(searchTerm ? { search: searchTerm } : {}),
            employee_id: useEmployeeId(),
        },
    });
    const { data: qualificationData, isLoading: qualificationDataIsLoading } =
        useGetQualificationsQuery(
            {
                items_per_page: 9999,
                filter: {
                    ...(brancheId && plusId
                        ? { qualification_standard_id: [brancheId, plusId] }
                        : {}),
                },
            },
            {
                skip: !brancheId && !plusId,
            },
        );

    if (
        establishmentsDataIsFetching ||
        establishmentsDataIsLoading ||
        qualificationDataIsLoading
    ) {
        return (
            <Skeleton
                containerClassName={"p-establishments__content"}
                className={"p-establishments__content__skeleton"}
                inline={true}
                count={6}
                height={"30rem"}
                borderRadius={"1.5rem"}
            />
        );
    }

    if (!establishmentsData?.data?.length || !qualificationData?.data?.length) {
        return (
            <EmptyListNotice content={"Er zijn geen vestigingen gevonden"} />
        );
    }

    return (
        <div className={"p-establishments__content"}>
            {establishmentsData.data.map((establishment) => {
                const address = `${establishment.address.street} ${establishment.address.house_number}, ${establishment.address.zip_code} ${establishment.address.city}`;
                const branchQualificationsAcquiredCount =
                    establishment.qualification_count_data
                        .branche_qualifications_acquired_count;
                const plusQualificationsAcquiredCount =
                    establishment.qualification_count_data
                        .plus_qualifications_acquired_count;

                return (
                    <EstablishmentCard
                        className="p-establishments__content__card"
                        onClick={() => {
                            dispatch(setIsConformationModalOpen(true));
                            dispatch(setEstablishment(establishment));
                        }}
                        branchBackgroundColor={
                            branchQualificationsAcquiredCount >=
                            getTotalBrancheCount(qualificationData.data)
                                ? "#EEF9E3"
                                : "#E33F3F1A"
                        }
                        plusBackgroundColor="#FEF8F2"
                        plusColor="#1D2D58"
                        branchColor={"#1D2D58"}
                        title={establishment.name}
                        description={address}
                        branchText={`${branchQualificationsAcquiredCount} / ${getTotalBrancheCount(qualificationData.data)}`}
                        branchImage={
                            branchQualificationsAcquiredCount >=
                            getTotalBrancheCount(qualificationData.data)
                                ? checkCircleImage
                                : warningImage
                        }
                        plusText={`${plusQualificationsAcquiredCount} / ${getTotalPlusCount(qualificationData.data)}`}
                        backgroundImage={establishment.image_url}
                        buttonIcon={loginImage}
                        badge={establishment.badge}
                    />
                );
            })}
            <EstablishmentsPopup />
        </div>
    );
};
